import React from "react";
import { useSelector } from "react-redux";

import classes from "./CartWidget.module.css";
import CartWidgetBtn from "./components/cartWidgetBtn/CartWidgetBtn";
import CartWidgetList from "./components/cartWidgetList";

//cart widget is used to show the cart item details on to the header in to the main application
//it is called to the header main layout

const CartWidget = () => {
  const cartItems = useSelector((state) => state.cart.items);
  const hasCartItems = cartItems.length > 0;
  return (
    <div id="cartWidget" className={classes["cart-Wigdet"]}>
      {hasCartItems ? (
        <CartWidgetList cartWidItems={cartItems} />
      ) : (
        <p className={classes["cart-wd-empty"]}>
          There are no items in this cart
        </p>
      )}
      <CartWidgetBtn hasItemsInCartWd={hasCartItems} />
    </div>
  );
};

export default CartWidget;
